import React from "react";
import PropTypes from "prop-types";
import "../../styles/Card.scss";
import CardTitle from "../card-title/CardTitle";

const Card = (props) => {
    const { children, cardTitle, cardIcon, sabTitle = "", setModalShow } = props;
    return (
        <React.Fragment>
            <div className="card">
                <CardTitle title={cardTitle} icon={cardIcon} sabTitle={sabTitle} setModalShow={setModalShow} />
                {children}
            </div>
        </React.Fragment>
    )
};

CardTitle.propTypes = {
    cardTitle: PropTypes.string,
    cardIcon: PropTypes.string,
    children: PropTypes.element
}

export default Card;